import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

import { HomeRoutes } from './home.routing';
import { HomeComponent } from './home.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { DocumentComponent } from './document/document.component';
import { CalendarComponent } from './calendar/calendar.component';
import { BookComponent } from './book/book.component';
import { ProviderComponent } from './provider/provider.component';
import { EmployeeComponent } from './employee/employee.component';
import { SalesComponent } from './sales/sales.component';
import { CommonComponent } from './common/common.component';

import { GeneralComponent } from './setting/general/general.component';
import { ContractComponent } from './setting/contract/contract.component';

import { EmployeeService } from './employee/service/employee.service';
import { Employee } from './employee/model/employee.model';
import { SaleService } from './sales/service/sale.service';
import { Classify } from './sales/model/classify.model';
import { CommonService } from './common/service/common.service';
import { Common } from './common/model/common.model';
import { General } from './setting/general/model/general.model';
import { Address } from './setting/general/model/address.model';
import { EventModel } from './calendar/model/event.model';
import { CalendarService } from './calendar/service/calendar.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(HomeRoutes),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    })
  ],
  declarations: [HomeComponent,
    DashboardComponent,
    SidebarComponent,
    FooterComponent,
    NavbarComponent,
    DocumentComponent,
    CalendarComponent,
    BookComponent,
    ProviderComponent,
    EmployeeComponent,
    SalesComponent,
    CommonComponent,
    ContractComponent,
    GeneralComponent
  ],
  providers: [
    EmployeeService,
    Employee,
    SaleService,
    Classify,
    CommonService,
    Common,
    General, Address,
    EventModel,
    CalendarService
  ]
})
export class HomeModule { }